import { CSSProperties, ReactNode } from 'react';
import style from './zeroState.module.scss';
import LinkUrl from '../general/link/LinkUrl';

interface Props {
    icon?: ReactNode;
    title: string;
    text: string;
    action: {
        url: string;
        text: string;
    };
    content?: string;
    subcontent?: string;
    classes?: string[];
    css?: CSSProperties;
}

const ZeroState = ({icon, title, text, action, content, subcontent, classes = [], css}: Props) => {
  console.log(subcontent)
  return (
    <div className={`${style.zeroState} ${classes.join(' ')}`} style={css}>
      {icon ? <span className={style.icon}>{icon}</span> : <></>}
      <p className={style.title}>
        {title}
      </p>
      <p className={style.text}>
        {text}
      </p>
      {
        content
        ?
        <div className={style.content} dangerouslySetInnerHTML={{__html: content}} />
        : <></>
      }
      <LinkUrl text={action.text} url={action.url} classes={[style.action]} />
      {
        subcontent
        ?
        <div className={style.subcontent} dangerouslySetInnerHTML={{__html: subcontent}} />
        : <></>
      }
    </div>
  )
};

export default ZeroState;
